import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/home/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { keepAlive: true }
  },
  { 
    path: '/shelter',  
    component: () => import('@/views/shelter/main/ShelterPageMain.vue'), 
    meta: { title: '보호소', keepAlive: true }, 
    children: [
      { path: '', name: 'Shelter', redirect: { name: 'ProtectedAnimal' } },
      { path: 'animal', name: 'ProtectedAnimal', meta: { keepAlive: true }, component: () => import('@/views/shelter/tab/ProtectedAnimal.vue') },
      { path: 'shelter', name: 'ShelterList', meta: { keepAlive: true }, component: () => import('@/views/shelter/tab/ShelterList.vue') },
      { path: 'recommended',name: 'RecommendedAnimal', meta: { keepAlive: true },component: () => import('@/views/shelter/tab/RecommendedAnimal.vue') },
    ] 
  },
  { 
    path: '/shelter/animal/detail/:idx', 
    name: 'AnimalDetail', 
    component: () => import('@/views/shelter/animal/AnimalDetail.vue'), 
    props: true,  
    meta: { title: '동물 정보' } 
    
  },
  { 
    path: '/shelter/home/:idx', 
    component: () => import('@/views/shelter/home/ShelterHomePagerMain.vue'), 
    redirect: to => ({ name: 'ShelterHomeInfo', params: { idx: to.params.idx } }), // ✅ 기본 탭 보장
    meta: { title: '보호소 홈', keepAlive: true },
    props: true,  
    children: [
      { path: '', name: 'ShelterHomePager', meta: { keepAlive: true }, redirect: { name: 'ShelterHomeInfo' } },
      { path: 'info', name: 'ShelterHomeInfo', meta: { keepAlive: true }, component: () => import('@/views/shelter/home/tab/ShelterInfo.vue') },
      { path: 'animal', name: 'ShelterHomeAnimal', meta: { keepAlive: true }, component: () => import('@/views/shelter/home/tab/ShelterAnimal.vue') },
    ] 
  },
  { 
    path: '/lost', 
    name: 'Lost',
    component: () => import('@/views/lost/main/LostAnimal.vue'), 
    meta: { title: '실종', keepAlive: true } 
  },
  { 
    path: '/lost/detail/:idx', 
    name: 'LostDetail', 
    component: () => import('@/views/lost/detail/LostDetail.vue'), 
    props: true,  
    meta: { title: '실종 정보' } 
  },
  { 
    path: '/story', 
    name: 'Story', 
    component: () => import('@/views/story/main/StoryPageMain.vue'), 
    meta: { title: '스토리', keepAlive: true } 
  },
  { 
    path: '/story/detail/:idx', 
    name: 'StoryDetail', 
    component: () => import('@/views/story/detail/StoryDetail.vue'), 
    props: true,  
    meta: { title: '스토리 정보' } 
  },

  { 
    path: '/service/statistics', 
    name: 'Statistics', 
    component: () => import('@/views/service/Statistics.vue'), 
    props: true,  
    meta: { title: '통계' } 

  },

  { 
    path: '/service/statistics.html', 
    component: () => import('@/views/service/Statistics.vue'), 
    props: true,  
    meta: { title: '통계' } 

  },

  { 
    path: '/intro', 
    name: 'Intro', 
    component: () => import('@/views/intro/intro.vue'), 
    meta: { title: '소개' } 

  },
  { 
    path: '/sponsorship', 
    name: 'Sponsorship', 
    component: () => import('@/views/sponsorship/sponsorship.vue'), 
    meta: { title: '후원' } 

  },

  { 
    path: '/notice', 
    name: 'Notice', 
    component: () => import('@/views/service/notice/NoticeList.vue'), 
    meta: { title: '공지사항' } 

  },
  { 
    path: '/notice/detail/:idx', 
    name: 'NoticeDetail',
    component: () => import('@/views/service/notice/NoticeDetail.vue'), 
    props: (route) => {
      const s = window.history.state || {};
      // 일부 버전에선 사용자 state가 usr 아래에 들어갈 수 있으니 둘 다 시도
      const noticeJson = s.noticeJson ?? s.usr?.noticeJson ?? null;
      return {
        idx: route.params.idx,
        noticeJson,
      };
    },
    meta: { title: '공지사항 상세' } 
  },

  { 
    path: '/question', 
    name: 'Question', 
    component: () => import('@/views/service/question/QuestionList.vue'), 
    meta: { title: '자주하는 질문' } 

  },
  { 
    path: '/question/detail/:idx', 
    name: 'QuestionDetail',
    component: () => import('@/views/service/question/QuestionDetail.vue'), 
    props: (route) => {
      const s = window.history.state || {};
      // 일부 버전에선 사용자 state가 usr 아래에 들어갈 수 있으니 둘 다 시도
      const questionJson = s.questionJson ?? s.usr?.questionJson ?? null;
      return {
        idx: route.params.idx,
        questionJson,
      };
    },
    meta: { title: '자주하는 질문 상세' } 
  },

  { 
    path: '/benefit', 
    name: 'Benefit', 
    component: () => import('@/views/service/benefit/benefitList.vue'), 
    meta: { title: '혜택' } 

  },

  { 
    path: '/benefit/detail/:idx', 
    name: 'BenefitDetail',
    component: () => import('@/views/service/benefit/benefitDetail.vue'), 
    props: true,
    meta: { title: '혜택 상세' } 
  },

  { 
    path: '/campaign', 
    name: 'Campaign', 
    component: () => import('@/views/campaign/main/CampaignListMain.vue'), 
    meta: { title: '캠페인', keepAlive: true } 
  },
  {
    path: '/campaign/detail/:idx',
    component: () => import('@/views/campaign/detail/CampaignDetail.vue'),
    redirect: to => ({ name: 'CampaignInfo', params: { idx: to.params.idx } }), // ✅ 기본 탭 보장
    props: true,
    children: [
      { path: '', name: 'CampaignDetail', meta: { keepAlive: true }, redirect: { name: 'CampaignInfo' } },
      { path: 'info', name: 'CampaignInfo', meta: { keepAlive: true }, component: () => import('@/views/campaign/detail/tab/CampaignInfo.vue') },
      { path: 'animal', name: 'CampaignAnimal', meta: { keepAlive: true }, component: () => import('@/views/campaign/detail/tab/CampaignAnimal.vue') },
      { path: 'story', name: 'CampaignStory', meta: { keepAlive: true }, component: () => import('@/views/campaign/detail/tab/CampaignStory.vue') },
    ] 
  },

  {
    path: '/donation',
    component: () => import('@/views/donation/main/DonationListMain.vue'),
    redirect: to => ({ name: 'DonationList' }),
    props: true,
    children: [
      { path: '', name: 'DonationList', meta: { keepAlive: true }, component: () => import('@/views/donation/tab/DonationList.vue') },
      { path: 'review', name: 'DonationReviewList', meta: { keepAlive: true }, component: () => import('@/views/donation/tab/DonationReviewList.vue') },
    ]
  },
  { 
    path: '/donation/detail/:idx', 
    name: 'DonationDetail',
    component: () => import('@/views/donation/detail/DonationDetail.vue'), 
    props: true,
    meta: { title: '포인기부 상세' } 
  },

  { 
    path: '/:pathMatch(.*)*', 
    redirect: '/' 
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return { ...savedPosition, behavior: 'auto' } // 👈 여기서 강제로 끔
    }
    return { left: 0, top: 0, behavior: 'auto' }   // 기본 이동도 auto
  },

})

router.afterEach((to) => {
  const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", `https://pawinhand.kr${to.fullPath}`);
  } else {
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", `https://pawinhand.kr${to.fullPath}`);
    document.head.appendChild(link);
  }
});

export default router
